// extracted by mini-css-extract-plugin
export var header = "_95-0";